<template>
  <div>
    <div ref="sliderContainer" class="sliderContainer">
      <div ref="sliderBg" class="sliderBg"></div>
      <div ref="sliderText" class="sliderText">{{sliderText}}</div>
      <div ref="sliderHandler" :class="sliderHandlerCls"></div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      // 滑块区文字
      sliderText: '向右拖动滑块进行验证',
      sliderHandlerCls: 'sliderHandler sliderHandlerBg'
    }
  },
  props: ['onsuccess'],
  mounted: function () {
    this.initSlider()
  },
  methods: {
    // 初始化滑块的方法
    initSlider() {
      // 给滑块添加鼠标按下监听
      this.$refs.sliderHandler.addEventListener('mousedown', this.onSliderHandlerMouseDown)
      // 初始化滑块距离左侧位置
      this.$refs.sliderHandler.style.left = 0
      // 初始化滑块绿色背景宽度
      this.$refs.sliderBg.style.width = 0
    },
    // 选中滑块时,添加监听
    onSliderHandlerMouseDown() {
      // 鼠标移动监听
      document.addEventListener('mousemove', this.onSliderHandlerMouseMove)
      // 鼠标松开监听
      document.addEventListener('mouseup', this.onSliderHandlerMouseUp)
    },
    // 滑块移动
    onSliderHandlerMouseMove(event) {
      // 1.获取滑动控件容器【左上顶点】距离【浏览器】左边界的x位移量
      var containerX = this.$refs.sliderContainer.getBoundingClientRect().left
      // 2.获取鼠标点击处距离【浏览器】左边界的x位移量
      var mouseX = event.clientX
      // xMove 滑块在x轴方向上移动量(默认拖拽点都是以dom元素左上顶点x来计算的,而我们人类习惯于拖拽点为中心点，故需要额外减去一半的滑块宽度)
      var xMove = mouseX - containerX - this.$refs.sliderHandler.clientWidth / 2
      // 滑块的最大偏移量 = 滑动验证容器总宽度 - 滑块宽度
      var maxHandlerOffset = this.$refs.sliderContainer.clientWidth - this.$refs.sliderHandler.clientWidth

      if (xMove < 0) {
        xMove = 0
      } else if (xMove > maxHandlerOffset) {
        // 如果滑块移动量 > 滑块的最大偏移量，则调用验证成功函数
        xMove = maxHandlerOffset
        this.verifySucc()
      }
      // 滑块移动量
      this.$refs.sliderHandler.style.left = xMove + 'px'
      // 绿色背景的长度 = 滑块移动量
      this.$refs.sliderBg.style.width = this.$refs.sliderHandler.style.left
    },
    // 松开滑块时,移除监听
    onSliderHandlerMouseUp() {
      // 移除鼠标移动监听
      document.removeEventListener('mousemove', this.onSliderHandlerMouseMove)
      // 移除鼠标松开监听
      document.removeEventListener('mouseup', this.onSliderHandlerMouseUp)
      // 初始化滑块移动量
      this.$refs.sliderHandler.style.left = 0
      // 初始化绿色背景
      this.$refs.sliderBg.style.width = 0
    },
    // 验证成功
    verifySucc() {
      // 改变提示文字内容
      this.sliderText = '验证通过'
      // 改变提示文字颜色
      this.$refs.sliderText.style.color = 'white'
      // 改变滑块内符号样式
      this.$refs.sliderHandler.setAttribute('class', 'sliderHandler sliderHandlerOkBg')
      // 移除鼠标按下监听
      this.$refs.sliderHandler.removeEventListener('mousedown', this.onSliderHandlerMouseDown)
      // 移除鼠标移动监听
      document.removeEventListener('mousemove', this.onSliderHandlerMouseMove)
      // 移除鼠标松开监听
      document.removeEventListener('mouseup', this.onSliderHandlerMouseUp)
      // 调用成功的回调函数
      this.onsuccess()
    }
  }
}
</script>

<style scoped>
/* 滑动控件容器,灰色背景 */
.sliderContainer {
  position: relative;
  background-color: #e8e8e8;
  width: 100%;
  height: 40px;
  border: 2px solid #e8e8e8;
  box-sizing: border-box;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  /* 文本不允许选中 */
  user-select: none;
  -webkit-user-select: none;
}

/* 滑块左边部分,绿色背景 */
.sliderBg {
  position: absolute;
  background-color:#7ac23c ;
  width: 0px;
  height: 100%;
  /* 文本不允许选中 */
  user-select: none;
  -webkit-user-select: none;
}

/* 滑动验证容器文本 */
.sliderText {
  font-size:16px;
  color: white;
  position: absolute;
  width: 100%;
  height: 100%;
  /* 文字水平居中 */
  text-align: center;
  /* 文字垂直居中,这里不能用百分比,因为百分比是相对原始line-height的,而非div高度 */
  line-height: 35px;
  /* 文本不允许选中 */
  user-select: none;
  -webkit-user-select: none;
}

.sliderHandler {
  position: absolute;
  width: 40px;
  height: 100%;
  cursor: move;
  /* 文本不允许选中 */
  user-select: none;
  -webkit-user-select: none;
}

/* 滑块初始背景 */
.sliderHandlerBg {
  background: #fff no-repeat center
    url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA3hpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNS1jMDIxIDc5LjE1NTc3MiwgMjAxNC8wMS8xMy0xOTo0NDowMCAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDo0ZDhlNWY5My05NmI0LTRlNWQtOGFjYi03ZTY4OGYyMTU2ZTYiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6NTEyNTVEMURGMkVFMTFFNEI5NDBCMjQ2M0ExMDQ1OUYiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6NTEyNTVEMUNGMkVFMTFFNEI5NDBCMjQ2M0ExMDQ1OUYiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTQgKE1hY2ludG9zaCkiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDo2MTc5NzNmZS02OTQxLTQyOTYtYTIwNi02NDI2YTNkOWU5YmUiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6NGQ4ZTVmOTMtOTZiNC00ZTVkLThhY2ItN2U2ODhmMjE1NmU2Ii8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+YiRG4AAAALFJREFUeNpi/P//PwMlgImBQkA9A+bOnfsIiBOxKcInh+yCaCDuByoswaIOpxwjciACFegBqZ1AvBSIS5OTk/8TkmNEjwWgQiUgtQuIjwAxUF3yX3xyGIEIFLwHpKyAWB+I1xGSwxULIGf9A7mQkBwTlhBXAFLHgPgqEAcTkmNCU6AL9d8WII4HOvk3ITkWJAXWUMlOoGQHmsE45ViQ2KuBuASoYC4Wf+OUYxz6mQkgwAAN9mIrUReCXgAAAABJRU5ErkJggg==");
}

/* 验证成功时的滑块背景 有√*/
.sliderHandlerOkBg {
  background: #fff no-repeat center
    url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA3hpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNS1jMDIxIDc5LjE1NTc3MiwgMjAxNC8wMS8xMy0xOTo0NDowMCAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDo0ZDhlNWY5My05NmI0LTRlNWQtOGFjYi03ZTY4OGYyMTU2ZTYiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6NDlBRDI3NjVGMkQ2MTFFNEI5NDBCMjQ2M0ExMDQ1OUYiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6NDlBRDI3NjRGMkQ2MTFFNEI5NDBCMjQ2M0ExMDQ1OUYiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTQgKE1hY2ludG9zaCkiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDphNWEzMWNhMC1hYmViLTQxNWEtYTEwZS04Y2U5NzRlN2Q4YTEiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6NGQ4ZTVmOTMtOTZiNC00ZTVkLThhY2ItN2U2ODhmMjE1NmU2Ii8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+k+sHwwAAASZJREFUeNpi/P//PwMyKD8uZw+kUoDYEYgloMIvgHg/EM/ptHx0EFk9I8wAoEZ+IDUPiIMY8IN1QJwENOgj3ACo5gNAbMBAHLgAxA4gQ5igAnNJ0MwAVTsX7IKyY7L2UNuJAf+AmAmJ78AEDTBiwGYg5gbifCSxFCZoaBMCy4A4GOjnH0D6DpK4IxNSVIHAfSDOAeLraJrjgJp/AwPbHMhejiQnwYRmUzNQ4VQgDQqXK0ia/0I17wJiPmQNTNBEAgMlQIWiQA2vgWw7QppBekGxsAjIiEUSBNnsBDWEAY9mEFgMMgBk00E0iZtA7AHEctDQ58MRuA6wlLgGFMoMpIG1QFeGwAIxGZo8GUhIysmwQGSAZgwHaEZhICIzOaBkJkqyM0CAAQDGx279Jf50AAAAAABJRU5ErkJggg==");
}
</style>
